import React, { useState } from "react";
import css from "./ResetPassword.module.scss";
// import { NavLink } from "react-router-dom";
import { bg_reset_password } from "../../../Images";
import { DoSendOTP } from "../../../Services/AuthServices";
import { useForm } from "react-hook-form";
// import { NavLink } from "react-router-dom";

import { NavLink, useNavigate } from 'react-router-dom';
import PlantManagementCoachMark from "../../HomePage/PlantManagementCoachMark";

const ResetPasswordPage = () => {
  const {register, handleSubmit, formState: { errors }} = useForm();
  const navigation = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [ErrorType, setErrorType] = useState(0);
  
  const doSendOtp = async (data) => {
    try {
      const execute = await DoSendOTP(data);
      setErrorType(execute.status)
      setShowPopup(true)
      localStorage.setItem("email_forgot", data.email);
    } catch (error) {
      setErrorType(error.response.status)
      setShowPopup(true)
    }
  };
  
  return (
    <div
      className="backgrund-cover-no-repeat"
      style={{ backgroundImage: `url(${bg_reset_password})`, height: "100vh" }}
    >
      {showPopup && 
          <>
          {ErrorType === 200 ?   
            <div className={css.popup_wrap} onClick={() => navigation('/verification')}>
              <div className={css.content_popup}>          
                <i class="fi fi-rr-cross-small" onClick={() => navigation('/verification')}></i>
                <img src="/monitoring/assets/success.png" />
                <b>Check Your Email</b>
                <p>Please check your email inbox to carry out the password reset process.</p>
              </div> 
            </div>
            :     
            <div className={css.popup_wrap} onClick={() => setShowPopup(false)}>      
              <div className={css.content_popup}>          
                <i class="fi fi-rr-cross-small" onClick={() => setShowPopup(false)}></i>
                <img src="/monitoring/assets/warning.png" />
                <b>Invalid or Unregistered Email</b>
                <p>Please enter a valid registered email address.</p>
              </div>
            </div> 
          }
          </>
      }
      <form onSubmit={handleSubmit(doSendOtp)}>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3">
              <div className={css.header_dark}>
                <NavLink to="/login">
                  <div className={css.back_button}>
                    <i class="fi-rr-arrow-small-left" />
                  </div>
                  <label>Forgot Password</label>
                </NavLink>
              </div>
            </div>
          </div>
          
            <div className={css.wrap_form_login}>
              <div className="row pt-4">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 text-center">
                  <div className={css.title}>Find Your Account</div>
                </div>
              </div>
              <div className="row p-3">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 pb-4 background-gray">
                  <label>Email</label>
                  <input type="text" placeholder="Enter Email" 
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address"
                    }
                  })}
                  />
                  {errors.email && <label className={css.error_message}>{errors.email.message}</label>}
                </div>
              </div>
            </div>
        </div>
        
        <div className={css.button_bottom_wrap}>
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <button>Send</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ResetPasswordPage;
